export const PAYMENT_TYPE_LIST = "PAYMENT_TYPE_LIST";
export const Online_PAYMENT_TYPE_LIST = "Online_PAYMENT_TYPE_LIST";